import { render, staticRenderFns } from "./rh_dashboard_lider.vue?vue&type=template&id=67346e0b&scoped=true&"
import script from "./rh_dashboard_lider.vue?vue&type=script&lang=js&"
export * from "./rh_dashboard_lider.vue?vue&type=script&lang=js&"
import style0 from "./rh_dashboard_lider.vue?vue&type=style&index=0&id=67346e0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67346e0b",
  null
  
)

export default component.exports